module.exports = __webpack_public_path__ + "media/images/ic-masonry-425ae63ae82cc7346624d045bee2a293.svg";